import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Report, Service } from './models';

@Injectable({ providedIn: 'root' })
export class AdminService {
  private readonly base = '/api';
  private token = '101b5fe0-5f4d-4a5f-9ea0-7884c69f6108';

  constructor(private http: HttpClient) {}

  // Set in production so write calls carry the admin token. Empty is fine for local dev.
  setToken(t: string): void { this.token = t || ''; }

  private opts(): { headers?: Record<string, string> } {
    return this.token ? { headers: { 'X-Admin-Token': this.token } } : {};
  }

  //----- Reports -----
  listReports(): Observable<Report[]> { return this.http.get<Report[]>(`${this.base}/reports`); }

  createReport(r: Report): Observable<Report> { return this.http.post<Report>(`${this.base}/reports`, r, this.opts()); }
  updateReport(slug: string, r: Report): Observable<Report> { return this.http.put<Report>(`${this.base}/reports/${slug}`, r, this.opts()); }

  publishReport(slug: string): Observable<Report> { return this.http.post<Report>(`${this.base}/reports/${slug}/publish`, {}, this.opts()); }
  retireReport(slug: string): Observable<Report> { return this.http.post<Report>(`${this.base}/reports/${slug}/retire`, {}, this.opts()); }
  reorderReports(slugs: string[]): Observable<void> { return this.http.post<void>(`${this.base}/reports/reorder`, slugs, this.opts()); }

  // ----- services -----
  listServices(): Observable<Service[]> { return this.http.get<Service[]>(`${this.base}/services`); }
  createService(s: Service): Observable<Service> { return this.http.post<Service>(`${this.base}/services`, s, this.opts()); }
  updateService(slug: string, s: Service): Observable<Service> { return this.http.put<Service>(`${this.base}/services/${slug}`, s, this.opts()); }
  setServiceStatus(slug: string, status: string): Observable<Service> { return this.http.post<Service>(`${this.base}/services/${slug}/status/${status}`, {}, this.opts()); }
  reorderServices(slugs: string[]): Observable<void> { return this.http.post<void>(`${this.base}/services/reorder`, slugs, this.opts()); }
}
